<template>
  <div>
    <v-row>
      <!-- Exercise column -->
      <v-col cols="12">
        <exercise-logic
          :exCollection="$route.meta.model"
          @ready="onReady"
          @error="onError"
          @saved="onSaved"
          @savedNext="onSavedNext"
          @loadedEx="onLoadedEx"
          :doc="doc"
          :shared="true"
          :pid="false"
        >
          <template slot-scope="{ saveExercise }">
            <v-stepper v-model="e1">
              <v-stepper-header>
                <v-stepper-step
                  color="amber"
                  :complete="e1 > 1"
                  :step="1"
                  @click="e1 = 1"
                  v-text="$t(`${$route.meta.content}.step1.title`)"
                ></v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step
                  color="amber"
                  :complete="e1 > 2"
                  :step="2"
                  @click="e1 = 2"
                  v-text="$t(`${$route.meta.content}.step2.title`)"
                ></v-stepper-step>
                <v-divider></v-divider>
              </v-stepper-header>

              <v-stepper-items>
                <v-stepper-content :step="1">
                  <brand-architecture-step1 v-model="doc.brands" v-if="doc" />

                  <bottom-navigation
                    :save="true"
                    :next="true"
                    :prev="false"
                    :gridView="false"
                    :gridToggle="false"
                    @save="saveExercise(true)"
                    @prev="prevStep"
                    @next="nextStep"
                  >
                  </bottom-navigation>
                </v-stepper-content>

                <v-stepper-content :step="2">
                  <brand-architecture-step2 v-model="doc.brands" v-if="doc" />

                  <bottom-navigation
                    :save="true"
                    :next="false"
                    :prev="true"
                    :gridView="false"
                    :gridToggle="false"
                    @save="saveExercise(true)"
                    @prev="prevStep"
                    @next="nextStep"
                  >
                  </bottom-navigation>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </template>
        </exercise-logic>
      </v-col>
    </v-row>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from "vuex";
import { BottomNavigation } from "@/components/core";
import { ExerciseLogic } from "@/components/exercises";

import {
  BrandArchitectureStep1,
  BrandArchitectureStep2,
} from "@/views/user/exercises/brand-architecture";

export default {
  name: "UserQuadrants",
  data() {
    return {
      e1: 1,
      exercises: null,
      refs: null,
      dialog: false,
      dialogMode: "",
      doc: {
        brands: [],
      },
      debug: false,
    };
  },
  components: {
    BottomNavigation,
    ExerciseLogic,
    BrandArchitectureStep1,
    BrandArchitectureStep2,
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
    isAdmin() {
      return this.currentUser.uid === "4jd41CisaJZmDYMwCGMRhFclhXY2";
    },
  },
  mounted() {},

  methods: {
    nextStep() {
      this.e1++;
      console.log("next step");
    },
    prevStep() {
      this.e1--;
    },
    onReady() {},
    onError() {
      console.log("error");
    },
    onSaved() {
      console.log("saved ex");
      this.dialogMode = "";
      this.dialog = true;
    },
    onLoadedEx(items) {
      console.log("loaded", items);
      if (items) {
        this.doc = items.doc;
      }
    },
    onSavedNext() {
      this.nextStep();
    },
  },
};
</script>

<style lang="scss"></style>
